import { render, staticRenderFns } from "./sell.vue?vue&type=template&id=1fcf2960&scoped=true&"
import script from "./sell.vue?vue&type=script&lang=js&"
export * from "./sell.vue?vue&type=script&lang=js&"
import style0 from "./sell.vue?vue&type=style&index=0&id=1fcf2960&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcf2960",
  null
  
)

export default component.exports